import { Link } from 'react-router-dom';
import type { GossipArticle } from '@/mocks/gossip';

type Props = {
  article: GossipArticle;
  variant?: 'default' | 'compact';
};

export default function ArticleCard({ article, variant = 'default' }: Props) {
  if (variant === 'compact') {
    return (
      <article className="group flex items-start gap-4 border-b border-background-200 py-4 last:border-b-0">
        <Link
          to={`/gossip/${article.id}`}
          className="relative h-16 w-24 shrink-0 overflow-hidden rounded-md"
          aria-label={article.title}
        >
          <img
            src={article.cover}
            alt={article.title}
            title={`${article.title} - 爆瓜福利`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </Link>
        <div className="min-w-0">
          <Link to={`/gossip/${article.id}`}>
            <h3 className="line-clamp-2 text-sm font-medium leading-6 text-foreground-900 transition-colors group-hover:text-primary-700">
              {article.title}
            </h3>
          </Link>
          <div className="mt-2 flex items-center gap-3 text-xs text-foreground-500">
            <span className="rounded bg-secondary-100 px-2 py-0.5 text-secondary-800">{article.category}</span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {article.views.toLocaleString('zh-CN')}
            </span>
          </div>
        </div>
      </article>
    );
  }

  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link to={`/gossip/${article.id}`} className="relative block h-48 overflow-hidden" aria-label={article.title}>
        <img
          src={article.cover}
          alt={article.title}
          title={`${article.title} - 爆瓜福利`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
          {article.category}
        </span>
        {article.hot && (
          <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-primary-700">
            <i className="ri-fire-fill"></i>
            热
          </span>
        )}
      </Link>
      <div className="flex flex-1 flex-col p-5">
        <Link to={`/gossip/${article.id}`}>
          <h3 className="line-clamp-2 font-heading text-base font-bold leading-7 text-foreground-950 transition-colors group-hover:text-primary-700">
            {article.title}
          </h3>
        </Link>
        <p className="mt-3 line-clamp-3 flex-1 text-sm leading-6 text-foreground-600">{article.summary}</p>
        <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-4 text-xs text-foreground-500">
          <span className="flex items-center gap-1.5">
            <i className="ri-user-3-line"></i>
            {article.author}
          </span>
          <span className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {article.views.toLocaleString('zh-CN')}
            </span>
            <span>{article.readTime}</span>
          </span>
        </div>
      </div>
    </article>
  );
}